import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import ProjectPersonnelTab from 'components/projectPersonnel/components/ProjectPersonnelTab';
import { ProjectPersonnelContext } from 'components/projectPersonnel/contexts/ProjectPersonnelContext';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper {...contextProps}>
        <ProjectPersonnelContext.Provider value={{ ...wrappedProps }}>
          <ProjectPersonnelTab />
        </ProjectPersonnelContext.Provider>
      </AppWrapper>
    </QueryClientProvider>
  );
}

EntryPoint.propTypes = {
  wrappedProps: PropTypes.exact({
    companyRolePolicy: PropTypes.exact({
      canIndex: PropTypes.bool.isRequired,
    }).isRequired,
    personnelPolicy: PropTypes.exact({
      canRead: PropTypes.bool.isRequired,
    }).isRequired,
    personnelProfileAccessPolicy: PropTypes.exact({
      canUpdate: PropTypes.bool.isRequired,
    }).isRequired,
    projectId: PropTypes.string.isRequired,
    projectPersonnelNestedCompanyRolePolicy: PropTypes.exact({
      canCreate: PropTypes.bool.isRequired,
    }).isRequired,
    projectPersonnelPolicy: PropTypes.exact({
      canCreate: PropTypes.bool.isRequired,
      canDestroy: PropTypes.bool.isRequired,
      canUpdate: PropTypes.bool.isRequired,
    }).isRequired,
    reviewPolicy: PropTypes.exact({
      canCreate: PropTypes.bool.isRequired,
      canRemind: PropTypes.bool.isRequired,
      canReset: PropTypes.bool.isRequired,
    }).isRequired,
    projectStartDate: PropTypes.string,
    teamPersonnelPolicy: PropTypes.exact({
      canWrite: PropTypes.bool.isRequired,
    }).isRequired,
    teamPolicy: PropTypes.exact({
      canIndex: PropTypes.bool.isRequired,
    }).isRequired,
  }),
};
